import { api } from "../../../utils/api";

// 🔹 Get all vendors
export const getVendors = (page = 1) => {
  return api.get(`/vendors?page=${page}`);
};

// 🔹 Get vendor by ID
export const getVendorById = (id) => {
  return api.get(`/vendors/${id}`);
};

// 🔹 Create vendor
export const createVendor = (data) => {
  return api.post("/vendors", data);
};

// 🔹 Update vendor
export const updateVendor = (id, data) => {
  return api.put(`/vendors/${id}`, data);
};

// 🔹 Delete vendor
export const deleteVendor = (id) => {
  return api.delete(`/vendors/${id}`);
};

// 🔹 Upload vendor document
export const uploadVendorDocument = (vendorId, file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("file", file);

  return api.post(`/vendors/${vendorId}/documents`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => {
      if (!progressEvent.total) return;

      const percent = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );

      if (onUploadProgress) onUploadProgress(percent);
    },
  });
};

// 🔹 Get Vendor Documents
export const getVendorDocuments = (vendorId) => {
  return api.get(`/vendors/${vendorId}/documents`);
};

//view venod documet
export const viewVendorDocument = async (docId) => {
  return await api.get(`vendors/vendors-files/view/${docId}`, {
    responseType: "blob",
  });
}

// 🔹 Delete Vendor Document
export const deleteVendorDocument = (docId) => {
  return api.delete(`/vendors/document/${docId}`);
};

// 🔹 Download Vendor Document
export const downloadVendorDocument = async (docId) => {
  return api.get(`/vendors/vendors-files/download/${docId}`, {
    responseType: "blob",
  });
};